import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { BakeItem } from "../../model/bakeItem";
import useBakeService from "../../services/useBakeService";
import { Button, StyledRouterLink } from "../../styling/card";
import { Loading } from "../Loading/Loading";
import {
  CardInformation,
  TitleWrapper,
  IconWrapper,
  Title,
  ButtonContainer,
  RegistrationText,
  Text,
  TextWrapper,
  LoadingWrapper,
} from "./BakeCard.styles";
import { PlaceholderCard } from "./PlaceholderCard";
import { ReactComponent as BakingIcon } from "../../images/baking-icon.svg";

interface BakeInformationProps {
  bakeData: BakeItem;
}

const getDateFormat = (isoString: string) => {
  const month = new Date(isoString).toLocaleString("default", {
    month: "long",
  });
  const date = new Date(isoString).getDate();
  const hours = new Date(isoString).getHours();
  const mins = new Date(isoString).getMinutes();

  return `${date} ${month} at ${hours}:${mins < 10 ? "0" + mins : mins}`;
};

const BakeInformation: React.FC<BakeInformationProps> = ({ bakeData }) => {
  return (
    <CardInformation>
      <TitleWrapper>
        <IconWrapper>
          <BakingIcon />
        </IconWrapper>
        <TextWrapper>
          <Title>Next Bake</Title>
          <Text>{bakeData.name}</Text>
        </TextWrapper>
      </TitleWrapper>
      <TitleWrapper>
        <IconWrapper>
          <FontAwesomeIcon icon="calendar-alt" size={"2x"} />
        </IconWrapper>
        <TextWrapper>
          <Title>When</Title>
          <Text>{bakeData.date}</Text>
        </TextWrapper>
      </TitleWrapper>
      <TitleWrapper>
        <IconWrapper>
          <FontAwesomeIcon icon="map-marker-alt" size={"2x"} />
        </IconWrapper>
        <TextWrapper>
          <Title>Where</Title>
          <Text>{bakeData.location}</Text>
        </TextWrapper>
      </TitleWrapper>
      {bakeData.notes && (
        <TitleWrapper>
          <IconWrapper>
            <FontAwesomeIcon icon="sticky-note" size={"2x"} />
          </IconWrapper>
          <TextWrapper>
            <Title>Notes</Title>
            <Text>{bakeData.notes}</Text>
          </TextWrapper>
        </TitleWrapper>
      )}

      <ButtonContainer>
        {bakeData.isLive ? (
          <StyledRouterLink
            to={{
              pathname: "/sessions",
              state: { bakeID: bakeData.id },
            }}
          >
            <Button>Register</Button>
          </StyledRouterLink>
        ) : (
          <RegistrationText>
            Registration opens {getDateFormat(bakeData.registerDateTime)}
          </RegistrationText>
        )}
      </ButtonContainer>
    </CardInformation>
  );
};

export const BakeCard: React.FC = () => {
  const bakeService = useBakeService();

  const { isLoading, bakeData } = bakeService;

  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
    );
  }

  return (
    <>
      {bakeData ? <BakeInformation bakeData={bakeData} /> : <PlaceholderCard />}
    </>
  );
};
